import { REQUEST_CATEGORIES, RECEIVE_CATEGORIES, FAILURE_CATEGORIES } from './constants';
import _ from 'lodash';
import { CALL_API } from '../../middlewares/api';

/**
 * Recupere les categories si elles ne sont pas deja dans le store
 */
export function fetchCategoriesIfNeeded() {
    return {
        [CALL_API]: {
            endpoint: '/category',
            types: [REQUEST_CATEGORIES, RECEIVE_CATEGORIES, FAILURE_CATEGORIES],
            shouldCallAPI: state => shouldFetchCategories(state)
        }
    };
}

/**
 * Retourne true si il faut effectuer le fetch pour récupèrer les catégories en bdd
 * @param {*Object} state
 */
function shouldFetchCategories(state) {
    const categories = _.omit(state.category.categories, 'loading');
    const loading = state.category.categories.loading;
    return !loading || _.isEmpty(categories);
}



// WEBPACK FOOTER //
// ./src/services/category/actions.js